import { _ } from "../../core/polyglot/polyglot.js";
import externalDocument from "../shared/externalDocument.js";

/**
 * `errorDocument' is used to render general errors.
 *
 * The document is not updated when its public API methods are
 * called.
 */

/**
 * Todo: Add JSDoc comment
 */
function errorDocument(spec, my) {
	my ||= {};

	let errorId;
	const that = externalDocument(my);

	that.setError = function (error) {
		errorId = error.id;
		that.update();
	};

	that.renderContentOn = function (html) {
		const error = getErrorFromId(errorId);

		html.div({ id: "document-title" }, html.h1(error.title));

		html.div(
			{ klass: "row" },
			html.div(
				{
					class: "col-lg-4 col-lg-offset-4 col-sm-6 col-sm-offset-3 text-center",
				},
				html.p({ klass: "lead" }, error.message),
				html.p(
					{ klass: "lead" },
					_("If the problem persists, please contact us."),
				),
			),
		);
	};

	function getErrorFromId(id) {
		switch (id) {
			case "XeroOauthRequestExpired": {
				return {
					title: _("Request timed out"),
					message: _(
						"The Xero authentication request has expired, please try again.",
					),
				};
			}
			case "SignUpRequestNotFound": {
				return {
					title: _("Request not found"),
					message: _(
						"Your request has either timed out or it is no longer available, please try again.",
					),
				};
			}
			case "SignUpRequestUnknownError": {
				return {
					title: _("Internal error"),
					message: _(
						"The system can not process your request at this time, please try again.",
					),
				};
			}
			default: {
				return {
					title: _("Some error occurred"),
					message: _(
						"Something went wrong, please report the issue to us.",
					),
				};
			}
		}
	}

	return that;
}

export default errorDocument;
